<script setup lang="ts">
import WebMap from "@/components/web-map/WebMap.vue"
import MAP003 from "@/data/map-003"
const map003 = MAP003
</script>

<template>
  <div class="mapview-container">
    <div class="row">
      <div class="col-md-12">
        <div id="webmap">
          <WebMap :stations="map003"></WebMap>
        </div>
      </div>
    </div>
  </div>
</template>
